module.exports = __webpack_public_path__ + "img/directory--icon.8674a0fc.svg";